import { render, staticRenderFns } from "./DebugPage.vue?vue&type=template&id=6893d04e&scoped=true&lang=pug&"
var script = {}
import style0 from "./DebugPage.vue?vue&type=style&index=0&id=6893d04e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893d04e",
  null
  
)

component.options.__file = "DebugPage.vue"
export default component.exports